package di

import com.kinoshazam.di.AUTH_USER
import com.kinoshazam.di.NONE_AUTH_USER
import com.kinoshazam.di.STORAGE_COMMON
import com.kinoshazam.di.STORAGE_SECURE
import com.kinoshazam.di.STORAGE_USER
import data.LoginRepository
import data.ProfileRepository
import data.VideoRepository
import data.db.delight.AppDatabase
import data.db.delight.daos.FavoriteVideoDao
import data.db.delight.daos.WatchProgressDao
import data.local.DelightLocalRepository
import features.videoDetails.VideoDetailsViewModel
import features.videoDetails.data.FavoriteInteractor
import features.videoDetails.data.FavoriteRepository
import features.watch.WatchProgressInteractor
import features.watch.data.WatchProgressRepository
import com.kinoshazam.taste.TasteInteractor
import com.kinoshazam.taste.TasteRepository
import org.koin.core.module.Module
import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.core.qualifier.named
import org.koin.dsl.module
import presentation.screens.RootViewModel
import presentation.screens.allVideos.AllVideosViewModel
import presentation.screens.appInfo.AppInfoViewModel
import presentation.screens.changePassword.ChangePasswordViewModel
import presentation.screens.decide.DecideViewModel
import presentation.screens.forgotPassword.ForgotPasswordViewModel
import presentation.screens.history.HistoryViewModel
import presentation.screens.login.LoginViewModel
import presentation.screens.main.MainViewModel
import presentation.screens.otp.OtpViewModel
import presentation.screens.person.PersonViewModel
import presentation.screens.profile.ProfileViewModel
import presentation.screens.search.SearchViewModel
import presentation.screens.videoPlayer.VideoPlayerViewModel
import presentation.screens.webPlayer.WebPlayerViewModel

fun commonModule() = module {

    factory {
        FavoriteInteractor(
            delightLocalRepository = get(),
            favoriteRepository = get(),
            globalStateRepository = get(),
            tokenRepository = get(),
        )
    }

    single<AppDatabase> { AppDatabase(databaseDriverFactory = get()) }
    single<FavoriteVideoDao> { FavoriteVideoDao(database = get()) }
    single<WatchProgressDao> { WatchProgressDao(database = get()) }
    single<VideoRepository> {
        VideoRepository(
            // AUTH so movie/tv details get per-user playback entitlement (optional JWT).
            httpClient = get(named(AUTH_USER)),
            globalStateRepository = get(),
        )
    }
    single<DelightLocalRepository> {
        DelightLocalRepository(
            favoriteVideoDao = get(),
            storage = get(named(STORAGE_COMMON)),
        )
    }
    single<LoginRepository> {
        LoginRepository(
            httpClient = get(named(NONE_AUTH_USER)),
            authHttpClient = get(named(AUTH_USER)),
            storageUser = get(named(STORAGE_USER)),
            storageSecure = get(named(STORAGE_SECURE))
        )
    }
    single<WatchProgressRepository> {
        WatchProgressRepository(httpClient = get(named(AUTH_USER)))
    }
    single {
        WatchProgressInteractor(
            dao = get(),
            repository = get(),
            videos = get(),
            globalStateRepository = get(),
            storage = get(named(STORAGE_COMMON)),
            tokenRepository = get(),
        )
    }
    single<FavoriteRepository> {
        FavoriteRepository(
            httpClient = get(named(AUTH_USER)),
            storageUser = get(named(STORAGE_USER)),
            globalStateRepository = get()
        )
    }
    single<ProfileRepository> {
        ProfileRepository(
            httpClient = get(named(AUTH_USER)),
            storage = get(named(STORAGE_COMMON))
        )
    }
    single<TasteRepository> {
        TasteRepository(httpClient = get(named(AUTH_USER)))
    }
    factory {
        TasteInteractor(
            tasteRepository = get(),
            storage = get(named(STORAGE_COMMON)),
        )
    }

    viewModelOf(::MainViewModel)

    viewModelOf(::SearchViewModel)

    viewModelOf(::VideoDetailsViewModel)

    viewModelOf(::AllVideosViewModel)

    viewModelOf(::PersonViewModel)

    viewModelOf(::WebPlayerViewModel)

    viewModelOf(::VideoPlayerViewModel)
    viewModelOf(::AppInfoViewModel)
    viewModel {
        RootViewModel(
            updateRepository = get(),
            localStorage = get(named(STORAGE_COMMON)),
            globalStateRepository = get(),
            profileRepository = get(),
            favoriteInteractor = get(),
            watchProgressInteractor = get(),
            tasteInteractor = get(),
            analytics = get(),
            tokenRepository = get(),
            crashReporter = get(),
        )
    }
    viewModelOf(::LoginViewModel)

    viewModelOf(::OtpViewModel)

    viewModelOf(::ProfileViewModel)
    viewModelOf(::HistoryViewModel)

    viewModelOf(::ChangePasswordViewModel)

    viewModelOf(::ForgotPasswordViewModel)

    viewModelOf(::DecideViewModel)
}

expect fun platformModule(): Module
